import React, { useState } from "react";

import DashboardGreeting from "../DashboardGreeting";

import AddIcon from "../../assets/images/addIcon.svg";
import AddLeaveType from "./AddLeaveType";
import EditLeaveType from "./EditLeaveType";
import Delete from "../common/CustomModals/Delete";

const LeaveConfiguration = ({ user }) => {
  const navHeading = "Leave Configuration";

  const [leaveType, setLeaveType] = useState(false);
  const [editLeaveType, setEditLeaveType] = useState(false);

  const [showDelete, setShowDelete] = useState(false);

  return (
    <>
      <div className="dashboard-container">
        <DashboardGreeting navHeading={navHeading} user={user} />
        <div className="filterBar mb-4">
          {user.role === "1" ? (
            <div className="action">
              <button
                className="apply feedback"
                onClick={(e) => {
                  setLeaveType(true);
                }}
              >
                <span>
                  <img src={AddIcon} alt="" />
                </span>
                <span>Add Leave Type</span>
              </button>
            </div>
          ) : (
            <>&nbsp;</>
          )}
        </div>
        <div className="leave-types2">
          <div className="list">
            <div className="item">
              <div className="flex">
                <div className="left-flex">
                  <span>
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_350_7616)">
                        <path
                          d="M26.25 2.62471L19.2439 2.62473V0.880859C19.2439 0.397422 18.8523 0.00585938 18.3689 0.00585938C17.8854 0.00585938 17.4939 0.397422 17.4939 0.880859V2.6243H10.4939V0.880859C10.4939 0.397422 10.1023 0.00585938 9.61888 0.00585938C9.13544 0.00585938 8.74388 0.397422 8.74388 0.880859V2.6243H1.75C0.783562 2.6243 0 3.40786 0 4.3743V26.2493C0 27.2157 0.783562 27.9993 1.75 27.9993H26.25C27.2164 27.9993 28 27.2157 28 26.2493V4.3743C28 3.40827 27.2164 2.62471 26.25 2.62471ZM26.25 26.2493H1.75V4.3743H8.74388V5.25586C8.74388 5.73927 9.13544 6.13086 9.61888 6.13086C10.1023 6.13086 10.4939 5.73927 10.4939 5.25586V4.37473H17.4939V5.25629C17.4939 5.73973 17.8854 6.13129 18.3689 6.13129C18.8523 6.13129 19.2439 5.73973 19.2439 5.25629V4.37473H26.25V26.2493ZM20.125 13.9997H21.875C22.358 13.9997 22.75 13.6077 22.75 13.1247V11.3747C22.75 10.8917 22.358 10.4997 21.875 10.4997H20.125C19.642 10.4997 19.25 10.8917 19.25 11.3747V13.1247C19.25 13.6077 19.642 13.9997 20.125 13.9997ZM20.125 20.9993H21.875C22.358 20.9993 22.75 20.6077 22.75 20.1243V18.3743C22.75 17.8913 22.358 17.4993 21.875 17.4993H20.125C19.642 17.4993 19.25 17.8913 19.25 18.3743V20.1243C19.25 20.6081 19.642 20.9993 20.125 20.9993ZM14.875 17.4993H13.125C12.642 17.4993 12.25 17.8913 12.25 18.3743V20.1243C12.25 20.6077 12.642 20.9993 13.125 20.9993H14.875C15.358 20.9993 15.75 20.6077 15.75 20.1243V18.3743C15.75 17.8917 15.358 17.4993 14.875 17.4993ZM14.875 10.4997H13.125C12.642 10.4997 12.25 10.8917 12.25 11.3747V13.1247C12.25 13.6077 12.642 13.9997 13.125 13.9997H14.875C15.358 13.9997 15.75 13.6077 15.75 13.1247V11.3747C15.75 10.8913 15.358 10.4997 14.875 10.4997ZM7.875 10.4997H6.125C5.642 10.4997 5.25 10.8917 5.25 11.3747V13.1247C5.25 13.6077 5.642 13.9997 6.125 13.9997H7.875C8.358 13.9997 8.75 13.6077 8.75 13.1247V11.3747C8.75 10.8913 8.358 10.4997 7.875 10.4997ZM7.875 17.4993H6.125C5.642 17.4993 5.25 17.8913 5.25 18.3743V20.1243C5.25 20.6077 5.642 20.9993 6.125 20.9993H7.875C8.358 20.9993 8.75 20.6077 8.75 20.1243V18.3743C8.75 17.8917 8.358 17.4993 7.875 17.4993Z"
                          fill="#988DAA"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_350_7616">
                          <rect width="28" height="28" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <span>Leave Type:</span>
                </div>
                <div className="right-flex">
                  <span>Earned Leave</span>
                </div>
              </div>
              <div className="flex">
                <div className="left-flex">
                  <span>
                    <svg
                      width="30"
                      height="28"
                      viewBox="0 0 30 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M26.46 4.2C26.46 3.4272 25.8014 2.8 24.99 2.8H4.41C3.59856 2.8 2.94 3.4272 2.94 4.2V23.8C2.94 24.5728 3.59856 25.2 4.41 25.2H24.99C25.8014 25.2 26.46 24.5728 26.46 23.8V4.2ZM29.4 2.8V25.2C29.4 26.747 28.0843 28 26.46 28H2.94C1.31565 28 0 26.747 0 25.2V2.8C0 1.253 1.31565 0 2.94 0H26.46C28.0843 0 29.4 1.253 29.4 2.8ZM20.6109 9.821C21.1856 10.367 21.1856 11.2546 20.6109 11.8006L14.8955 17.2438C14.0326 18.0642 12.6361 18.0642 11.7732 17.2438L9.17573 14.77C8.60243 14.224 8.60243 13.3378 9.17573 12.7904C9.7505 12.2444 10.681 12.2444 11.2543 12.7904L12.2921 13.7788C12.8669 14.3262 13.8004 14.3262 14.3766 13.7788L18.5323 9.821C19.1056 9.2736 20.0376 9.2736 20.6109 9.821Z"
                        fill="#988DAA"
                      />
                    </svg>
                  </span>
                  <span>Applicable For:</span>
                </div>
                <div className="right-flex">
                  <div>
                    <span>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M12 21C16.9706 21 21 16.9706 21 12C21 10.1666 20.4518 8.46124 19.5103 7.03891L12.355 14.9893C11.6624 15.7589 10.4968 15.8726 9.66844 15.2513L6.4 12.8C5.95817 12.4686 5.86863 11.8418 6.2 11.4C6.53137 10.9582 7.15817 10.8686 7.6 11.2L10.8684 13.6513L18.214 5.48955C16.5986 3.94717 14.4099 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                          fill="#2DCE89"
                        />
                      </svg>
                    </span>
                    <span>Monthly</span>
                  </div>
                  <div>
                    <span>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M12 21C16.9706 21 21 16.9706 21 12C21 10.1666 20.4518 8.46124 19.5103 7.03891L12.355 14.9893C11.6624 15.7589 10.4968 15.8726 9.66844 15.2513L6.4 12.8C5.95817 12.4686 5.86863 11.8418 6.2 11.4C6.53137 10.9582 7.15817 10.8686 7.6 11.2L10.8684 13.6513L18.214 5.48955C16.5986 3.94717 14.4099 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                          fill="#2DCE89"
                        />
                      </svg>
                    </span>
                    <span>Quarterly</span>
                  </div>
                  <div>
                    <span>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M12 21C16.9706 21 21 16.9706 21 12C21 10.1666 20.4518 8.46124 19.5103 7.03891L12.355 14.9893C11.6624 15.7589 10.4968 15.8726 9.66844 15.2513L6.4 12.8C5.95817 12.4686 5.86863 11.8418 6.2 11.4C6.53137 10.9582 7.15817 10.8686 7.6 11.2L10.8684 13.6513L18.214 5.48955C16.5986 3.94717 14.4099 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                          fill="#2DCE89"
                        />
                      </svg>
                    </span>
                    <span>Yearly</span>
                  </div>
                </div>
              </div>
              <div>
                <div className="flex">
                  <div className="left-flex">
                    <span>
                      <svg
                        width="31"
                        height="31"
                        viewBox="0 0 31 31"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_350_7628)">
                          <path
                            d="M31 15.5C31 19.6109 29.367 23.5533 26.4602 26.4602C23.5533 29.367 19.6109 31 15.5 31C11.3891 31 7.44666 29.367 4.53984 26.4602C1.63303 23.5533 0 19.6109 0 15.5C0 15.1574 0.136086 14.8289 0.37832 14.5867C0.620555 14.3444 0.949095 14.2083 1.29167 14.2083C1.63424 14.2083 1.96278 14.3444 2.20501 14.5867C2.44725 14.8289 2.58333 15.1574 2.58333 15.5C2.58333 18.0547 3.34088 20.552 4.76018 22.6761C6.17949 24.8002 8.19679 26.4558 10.557 27.4334C12.9172 28.4111 15.5143 28.6669 18.0199 28.1685C20.5255 27.6701 22.827 26.4399 24.6335 24.6335C26.4399 22.827 27.6701 20.5255 28.1685 18.0199C28.6669 15.5143 28.4111 12.9172 27.4334 10.557C26.4558 8.19679 24.8002 6.17949 22.6761 4.76018C20.552 3.34088 18.0547 2.58333 15.5 2.58333C15.1574 2.58333 14.8289 2.44725 14.5867 2.20501C14.3444 1.96278 14.2083 1.63424 14.2083 1.29167C14.2083 0.949095 14.3444 0.620555 14.5867 0.37832C14.8289 0.136086 15.1574 0 15.5 0C19.6095 0.00444473 23.5494 1.6389 26.4552 4.54475C29.3611 7.4506 30.9956 11.3905 31 15.5ZM13.2745 14.2083H10.3333C9.99076 14.2083 9.66222 14.3444 9.41999 14.5867C9.17775 14.8289 9.04167 15.1574 9.04167 15.5C9.04167 15.8426 9.17775 16.1711 9.41999 16.4133C9.66222 16.6556 9.99076 16.7917 10.3333 16.7917H13.2745C13.4717 17.1343 13.7452 17.4268 14.0737 17.6467C14.4022 17.8667 14.7769 18.008 15.1688 18.0598C15.5607 18.1117 15.9593 18.0726 16.3337 17.9456C16.708 17.8187 17.0482 17.6072 17.3277 17.3277C17.6072 17.0482 17.8187 16.708 17.9456 16.3337C18.0726 15.9593 18.1117 15.5607 18.0598 15.1688C18.008 14.7769 17.8667 14.4022 17.6467 14.0737C17.4268 13.7452 17.1343 13.4717 16.7917 13.2745V9.04167C16.7917 8.69909 16.6556 8.37055 16.4133 8.12832C16.1711 7.88609 15.8426 7.75 15.5 7.75C15.1574 7.75 14.8289 7.88609 14.5867 8.12832C14.3444 8.37055 14.2083 8.69909 14.2083 9.04167V13.2745C13.8214 13.4996 13.4996 13.8214 13.2745 14.2083ZM2.35987 11.346C2.61534 11.346 2.86507 11.2702 3.07749 11.1283C3.2899 10.9864 3.45546 10.7847 3.55322 10.5486C3.65098 10.3126 3.67656 10.0529 3.62672 9.80234C3.57688 9.55178 3.45386 9.32163 3.27322 9.14099C3.09258 8.96034 2.86243 8.83732 2.61187 8.78749C2.36131 8.73765 2.1016 8.76323 1.86558 8.86099C1.62955 8.95875 1.42782 9.12431 1.28589 9.33672C1.14396 9.54914 1.06821 9.79887 1.06821 10.0543C1.06821 10.3969 1.20429 10.7254 1.44653 10.9677C1.68876 11.2099 2.0173 11.346 2.35987 11.346ZM5.45213 6.72571C5.70759 6.72571 5.95732 6.64995 6.16974 6.50802C6.38215 6.36609 6.54771 6.16436 6.64547 5.92834C6.74323 5.69232 6.76881 5.43261 6.71897 5.18205C6.66913 4.93149 6.54611 4.70134 6.36547 4.5207C6.18483 4.34005 5.95468 4.21703 5.70412 4.16719C5.45356 4.11735 5.19385 4.14293 4.95783 4.2407C4.7218 4.33846 4.52007 4.50402 4.37814 4.71643C4.23621 4.92884 4.16046 5.17857 4.16046 5.43404C4.16046 5.77661 4.29654 6.10515 4.53878 6.34739C4.78101 6.58962 5.10955 6.72571 5.45213 6.72571ZM10.0479 3.66963C10.3033 3.66963 10.5531 3.59387 10.7655 3.45194C10.9779 3.31001 11.1435 3.10828 11.2412 2.87226C11.339 2.63624 11.3646 2.37653 11.3147 2.12597C11.2649 1.87541 11.1419 1.64525 10.9612 1.46461C10.7806 1.28397 10.5504 1.16095 10.2999 1.11111C10.0493 1.06127 9.7896 1.08685 9.55358 1.18461C9.31755 1.28238 9.11582 1.44793 8.97389 1.66035C8.83196 1.87276 8.75621 2.12249 8.75621 2.37796C8.75621 2.72053 8.89229 3.04907 9.13453 3.2913C9.37676 3.53354 9.7053 3.66963 10.0479 3.66963Z"
                            fill="#988DAA"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_350_7628">
                            <rect width="31" height="31" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                    <span>Duration:</span>
                  </div>
                  <div className="right-flex">
                    <div>
                      <span>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M12 21C16.9706 21 21 16.9706 21 12C21 10.1666 20.4518 8.46124 19.5103 7.03891L12.355 14.9893C11.6624 15.7589 10.4968 15.8726 9.66844 15.2513L6.4 12.8C5.95817 12.4686 5.86863 11.8418 6.2 11.4C6.53137 10.9582 7.15817 10.8686 7.6 11.2L10.8684 13.6513L18.214 5.48955C16.5986 3.94717 14.4099 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                            fill="#2DCE89"
                          />
                        </svg>
                      </span>
                      <span>Monthly</span>
                    </div>
                    <div>
                      <span>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M12 21C16.9706 21 21 16.9706 21 12C21 10.1666 20.4518 8.46124 19.5103 7.03891L12.355 14.9893C11.6624 15.7589 10.4968 15.8726 9.66844 15.2513L6.4 12.8C5.95817 12.4686 5.86863 11.8418 6.2 11.4C6.53137 10.9582 7.15817 10.8686 7.6 11.2L10.8684 13.6513L18.214 5.48955C16.5986 3.94717 14.4099 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                            fill="#2DCE89"
                          />
                        </svg>
                      </span>
                      <span>Quarterly</span>
                    </div>
                    <div>
                      <span>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M12 21C16.9706 21 21 16.9706 21 12C21 10.1666 20.4518 8.46124 19.5103 7.03891L12.355 14.9893C11.6624 15.7589 10.4968 15.8726 9.66844 15.2513L6.4 12.8C5.95817 12.4686 5.86863 11.8418 6.2 11.4C6.53137 10.9582 7.15817 10.8686 7.6 11.2L10.8684 13.6513L18.214 5.48955C16.5986 3.94717 14.4099 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                            fill="#2DCE89"
                          />
                        </svg>
                      </span>
                      <span>Yearly</span>
                    </div>
                  </div>
                </div>
                <div className="flex1">
                  <div className="flex">
                    <div className="left-flex">
                      <span>0 - 3 Years :</span>
                    </div>
                    <div className="right-flex">
                      <div>
                        <span>1.5 Days</span>
                      </div>
                      <div>
                        <span>4.5 Days</span>
                      </div>
                      <div>
                        <span>18 Days</span>
                      </div>
                    </div>
                  </div>
                  <div className="flex">
                    <div className="left-flex">
                      <span>3 - 5 Years :</span>
                    </div>
                    <div className="right-flex">
                      <div>
                        <span>1.75 Days</span>
                      </div>
                      <div>
                        <span>5.25 Days</span>
                      </div>
                      <div>
                        <span>21 Days</span>
                      </div>
                    </div>
                  </div>
                  <div className="flex">
                    <div className="left-flex">
                      <span>5 Years & above:</span>
                    </div>
                    <div className="right-flex">
                      <div>
                        <span>1.91 Days</span>
                      </div>
                      <div>
                        <span>5.75 Days</span>
                      </div>
                      <div>
                        <span>23 Days</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="action">
                <button>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={(e) => {
                      setEditLeaveType(true);
                    }}
                  >
                    <path
                      d="M16.7925 6.61653L6.90079 16.5082C6.01746 17.3999 3.37578 17.8081 2.77578 17.2165C2.17578 16.6248 2.60079 13.9832 3.48413 13.0916L13.3758 3.19989C13.8326 2.7649 14.4412 2.5257 15.0719 2.53338C15.7026 2.54107 16.3053 2.79504 16.7513 3.24104C17.1973 3.68703 17.4512 4.28973 17.459 4.92042C17.4666 5.55111 17.2275 6.1598 16.7925 6.61653Z"
                      stroke="#4E465E"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
                <button>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={(e) => {
                      setShowDelete(true);
                    }}
                  >
                    <path
                      d="M4 7H20"
                      stroke="#4E465E"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M6 10L7.70141 19.3578C7.87432 20.3088 8.70258 21 9.66915 21H14.3308C15.2974 21 16.1257 20.3087 16.2986 19.3578L18 10"
                      stroke="#4E465E"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z"
                      stroke="#4E465E"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`${leaveType ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setLeaveType(false);
          }}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <AddLeaveType leaveType={leaveType} />
          </div>
        </div>
        <div
          className={`${editLeaveType ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setEditLeaveType(false);
          }}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <EditLeaveType editLeaveType={editLeaveType} />
          </div>
        </div>

        <div
          className={`${showDelete ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setShowDelete(false);
          }}
        >
          <div className="" onClick={(e) => e.stopPropagation()}>
            <Delete
              heading="Are you sure you want to delete this leave type"
              para="Deleting this leave type will remove all its details."
              showDelete={showDelete}
              setShowDelete={setShowDelete}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default LeaveConfiguration;
